/* global VXConfig */
import React                                                 from 'react';
import PropTypes                                             from 'prop-types';
import Block                                                 from '../Block';
import Dailybonus                                            from '../../Dailybonus/Dailybonus';
import {EventConfigPropTypes}                                from '../../Dailybonus/EventConfigPropTypes';
import Flux                                                  from '../../../flux/Flux';
import Translations                                          from '../../../utils/Translations';
import {VXButtonLineConfig}                                  from '../../SimpleElements/VXButton/VXButtonConfig';
import {getDailyBonusTranslation, getSeoHeadlineTranslation} from '../../../utils/TranslationHelper';
import {trackClick}                                          from '../../../utils/GAHelper';
import withEventConfig                                       from '../../HigherOrderComponents/Dailybonus/withEventConfig';
import UrlBuilder                                            from '../../../utils/UrlBuilder';
import Header                                                from '../../Homepage/Block/Header';
import VXButtonOutline from '../../SimpleElements/VXButton/Presets/VXButtonOutline';


class DailybonusBlock extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isMobile: this.props.isMobile,
		};

		this.onWindowChange = this.onWindowChange.bind(this);
	}

	componentDidMount() {
		Flux.Browser.addWindowResizeListener(this.onWindowChange);
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowResizeListener(this.onWindowChange);
	}

	onWindowChange() {
		const isMobile = Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md;
		this.setState({isMobile});
	}

	getButton() {
		let ctaLink = this.props.link;
		if (this.props.event) {
			ctaLink = this.props.event.redirectUrl;
		}

		return <div className="h-mt-5 row cta-row"><VXButtonOutline line1={[new VXButtonLineConfig(Translations.get('HomepageDailyBonusCTA'))]}
		                                              link={ctaLink}
		                                              callback={() => trackClick('365', ctaLink)}
		                                              staticMode={true}/>
		</div>;
	}


	mobileView() {
		let description     = '';
		let title           = getSeoHeadlineTranslation(Flux.Browser.isSexole() ? 'homepage_365_h2--sexole' : 'homepage_365_h2');
		let backgroundImage = '';

		const blockClasses = ['dailybonus__mobile-block'];

		if (this.props.event) {
			blockClasses.push(this.props.event.className);
			description     = getDailyBonusTranslation(this.props.event.headerDescription) || this.props.event.headerDescription || '';
			title           = getDailyBonusTranslation(this.props.event.headerTitle) || this.props.event.headerTitle;
			backgroundImage = this.props.event.homepageBlockBg || '';
		}

		blockClasses.push('daily-bonus');

        const header = () => {
            const lang = VXConfig.language === 'de' ? '' : '_en';
            if (this.props.event && this.props.event.className.includes('-event-25-jahre')) {
                return <img className="dailybonus__logo" src={`/assets/img/twentyfiveyears/logo${lang}.png`} />;
            } else if (this.props.event && this.props.event.className.includes('-event-visit-xmas')) {
                return <img className="dailybonus__logo dailybonus__logo--center" src={`/assets/img/special/adventcalendar/365/365logo${lang}.svg`} />;
            } else {
                return <Header title={title}
                hasSubtitle={description.length > 0}
                subTitle={description}
                useSeparator={false}
                />;
            }
        };

		return (
			<Block className={blockClasses.join(' ')} backgroundImage={backgroundImage}>
				{header()}
				{<Dailybonus {...this.props} isMobile={this.state.isMobile}/>}
				{this.getButton()}
			</Block>
		);
	}


	desktopView() {
		const eventConfig      = this.props.event;
		const eventClassName   = eventConfig ? eventConfig.className + ' has-no-border' : '';
		const background       = eventConfig ? eventConfig.homepageBlockBg : '';
		const titleToken       = eventConfig ? eventConfig.headerTitle : null;
		const descriptionToken = eventConfig ? eventConfig.headerDescription : null;

		const titleTranslation = titleToken ? (getDailyBonusTranslation(titleToken) || Translations.get(titleToken)) : getSeoHeadlineTranslation(Flux.Browser.isSexole() ? 'homepage_365_h2--sexole' : 'homepage_365_h2');
		const descTranslation  = descriptionToken ? (getDailyBonusTranslation(descriptionToken) || Translations.get(descriptionToken)) : getSeoHeadlineTranslation(Flux.Browser.isSexole() ? 'homepage_365_h3--sexole' : 'homepage_365_h3');

		const headline = React.createElement(
			this.props.headlineType,
			{
				className:               'dailybonus__title',
				dangerouslySetInnerHTML: {__html: titleTranslation}
			}
		);

        const header = () => {
            const lang = VXConfig.language === 'de' ? '' : '_en';
            if (eventClassName.includes('-event-25-jahre')) {
                return <img className="dailybonus__logo" src={`/assets/img/twentyfiveyears/logo${lang}.png`} />;
            } else if (this.props.event && this.props.event.className.includes('-event-visit-xmas')) {
                return <img className="dailybonus__logo dailybonus__logo--center" src={`/assets/img/special/adventcalendar/365/365logo${lang}.svg`} />;
            } else {
                return <div className="row">
                <div className="col-md-12">
                    {headline}
                    <h3 className="dailybonus__description" dangerouslySetInnerHTML={{__html: descTranslation}}/>
                </div>
            </div>;
            }
        };

		return (
			<Block className={'dailybonus-block ' + eventClassName} backgroundImage={background} idName="dailybonus-block">
				<div className="dailybonus">
					<div className="container-fluid">
                        {header()}
						<Dailybonus {...this.props} isMobile={this.state.isMobile}/>
					</div>
					{this.getButton()}
				</div>
			</Block>
		);

	}

	render() {
		if (!this.props.show) {
			return null;
		}

		if (this.state.isMobile) {
			return this.mobileView();
		}

		return this.desktopView();
	}
}

DailybonusBlock.propTypes = {
	show:             PropTypes.bool,
	link:             PropTypes.string,
	lazyImageLoading: PropTypes.bool,
	headlineType:     PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
	doGaTracking:     PropTypes.bool,
	isMobile:         PropTypes.bool,
	event:            EventConfigPropTypes,
};

DailybonusBlock.defaultProps = {
	lazyImageLoading: false,
	headlineType:     Flux.Constants.Headlines.h2,
	doGaTracking:     false,
	link:             UrlBuilder.buildDailyBonusRoute(),
	isMobile:         true,
	event:            null,
	show:             true,
};

export default withEventConfig(DailybonusBlock);
